import styled from "styled-components";

import { SignalsListTypes } from "app/pages/sales-intelligence/common-components/SignalsListTypes/SignalsListTypes";

export const StyledSignalsListTypes = styled(SignalsListTypes)`
    margin-top: 16px;
`;
